import { Tier, validateTier } from '@squaredup/tenants';
import { ProjectedTenantResponse } from 'services/TenantService';
import { useTenant } from './useTenant';

type UseTierOptions = Omit<Parameters<typeof useTenant>[0], 'select'>;

// Use a stable function to ensure tier object doesn't change between renders
const selectTier = (tenant: ProjectedTenantResponse): Tier | undefined => {
    const result = validateTier(tenant.tier);
    return result.success ? result.data : undefined;
};

/**
 * useQuery returning the user's current tier.
 * Makes use of useTenant under the hood so remains fast and responsive to tenant changes.
 * @param options The react-query options e.g. refreshInterval
 * @returns Valid Tier object or undefined if the tenant tier is missing or malformed
 */
export const useTier = (options?: UseTierOptions) => {
    return useTenant({
        ...options,
        select: selectTier
    });
};
